import React, { useEffect, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl/dist';
import { Layouts } from 'app-components';
import NavBarContainer from '../../containers/common/NavBarContainer';
import Tabs from './Tab';
import { CHART_CONST_INFO } from '../../constants/common/chart/chartConst';
import UpcomingDueDateReport from './UpcomingDueDateReport';
import TodaysActivity from './TodaysActivity';

function UpcomingDueDate(props: { segmentBy:any, setSegmentBy:Function, selectedReport: string; RenderByWorkGroup: Function; changeReport: Function; showAssigneeSegment: boolean, idMapping:{}[], filterBySelectedWorkGroup: Function, isDrillDownActive: boolean, workGroupFilter,selectedChart }) {
    const { segmentBy,setSegmentBy, selectedReport, RenderByWorkGroup, changeReport, showAssigneeSegment,idMapping, filterBySelectedWorkGroup, isDrillDownActive, workGroupFilter,selectedChart } = props;
    const intl = useIntl();

    const RenderReportsDropDown = () => (
        <>
            <span>
                <strong><FormattedMessage id='duedate_report_dropdown_label' /></strong>
            </span>
            &ensp;
            <select name="selectReport"  id="selectedReport" value={selectedReport} onChange={(e)=>{changeReport(e.target.value)}}>
                {CHART_CONST_INFO.REPORTS_DROP_DOWN_OPTIONS.map((displayText, index)=>(
                    <option key={index} value={`${displayText}`}>{displayText}</option>
                ))}
            </select>
        </>
    )


    const RenderWorkGroupDropDown = () => (
        <>
            {selectedChart === CHART_CONST_INFO.ACTIVATE_WORKGROUP_BY_STATUS &&
                <>
                    <span>
                        <strong><FormattedMessage id='select_workgroup_dropdown_label' /></strong>
                    </span>
                    &ensp;
                    <select name="workGroup" id="workGroup" value={workGroupFilter} onChange={(e) => { filterBySelectedWorkGroup(e.target.value) }}>
                        <option key={'-1'} value={'-1'}>{intl.formatMessage({ id: 'select_workgroup_dropdown_select_label' })}</option>
                        {idMapping?.map((item: [number, string]) => (
                            <option key={Object.keys(item)[0]} value={Object.keys(item)[0]}>{Object.values(item)[0]}</option>
                        ))}
                    </select>
                </>
            }
        </>
    )

    return (
        <Layouts id='DueDate-Layout'>
            <Layouts.Row hasGap={true}>
                <div className='grid-col-12'>
                    <div className='grid-row'>
                        <NavBarContainer navBarClass='ticket-mgmt-top-nav grid-col-12' />
                    </div>
                    <div className='select-report-container'>
                        {<RenderReportsDropDown />}
                    </div>
                    {selectedReport === CHART_CONST_INFO.UPCOMING_DUE_DATES ?
                        <UpcomingDueDateReport
                            selectedReport={selectedReport}
                            RenderWorkGroupDropDown={RenderWorkGroupDropDown}
                            RenderByWorkGroup={RenderByWorkGroup}
                            segmentBy={segmentBy}
                            setSegmentBy={setSegmentBy}
                            isDrillDownActive={isDrillDownActive}
                        />
                        :
                        <TodaysActivity
                            selectedReport={selectedReport}
                            RenderByWorkGroup={RenderByWorkGroup}
                            segmentBy={segmentBy}
                            setSegmentBy={setSegmentBy}
                            isDrillDownActive={isDrillDownActive}
                            showAssigneeSegment={showAssigneeSegment}
                        />
                    }
                </div>
            </Layouts.Row>
        </Layouts>
    )
}

export default UpcomingDueDate